import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import popup_msg_sound_effect from "../../sounds/sentmessagesound.mp3";
import useSoundPlayer from "../authmodule/deshboard/commonmodal/useSoundPlayer";
const NotificationContext = createContext();
export const useNotification = () => useContext(NotificationContext);

export const NotificationProviderfordashboard = ({ children }) => {
  const popupSoundRef = useRef(null);
  const sounddata = useSelector((state) => state.usersound.sound);
  const { loadSound, playSound } = useSoundPlayer(0.1);
  const [notifications, setNotifications] = useState([]);
  const timersRef = useRef(null); // interval id
  const fadeDuration = 500; // ms (must match CSS transition)
  const displayDuration = 1200; // ms visible before starting fade
  const maxVisible = 4;
  const location = window.location;
  const pathSegments = location.pathname.split("/");
  const [addclass, setAddclass] = useState(false);
  useEffect(() => {
    loadSound("notification", popup_msg_sound_effect);
  }, []);
  const playPopupSound = () => {
    if (!sounddata) return;
    playSound("notification");
  };
  // useEffect(() => {
  //   popupSoundRef.current = new Audio(popup_msg_sound_effect)
  //   popupSoundRef.current.volume = 1.0;
  // }, []);
  // Add notification: uses expiresAt instead of per-notification timers
  const showNotification = (message, type = "success") => {
    const id = crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`;

    try {
      playPopupSound();
    } catch (err) {
      console.log("Dashboard popup sound error:", err);
    }
    const now = Date.now();
    const newNotification = {
      id,
      message,
      type,
      removing: false,
      createdAt: now,
      expiresAt: now + displayDuration, // when to start fade
    };

    setNotifications((prev) => {
      // place newest at front
      const updated = [newNotification, ...prev];

      // keep only maxVisible items (we prefer newest)
      if (updated.length > maxVisible) {
        updated.splice(maxVisible); // remove oldest beyond maxVisible
      }
      return updated;
    });
  };

  // Central cleanup loop: marks removing when expiresAt passed,
  // and removes after fadeDuration. Runs every 100ms (fast enough)
  useEffect(() => {
    // do not start multiple intervals
    if (timersRef.current) return;

    timersRef.current = setInterval(() => {
      setNotifications((prev) => {
        const now = Date.now();
        let changed = false;

        // Map notifications -> possibly updated objects
        const next = prev.map((n) => {
          // if not yet removing and expired -> mark removing and set removeAt
          if (!n.removing && n.expiresAt <= now) {
            changed = true;
            return { ...n, removing: true, removeAt: now + fadeDuration };
          }
          return n;
        });

        // Now remove any that have removeAt <= now
        const filtered = next.filter((n) => {
          if (n.removeAt && n.removeAt <= now) {
            changed = true;
            return false; // remove it
          }
          return true;
        });

        return changed ? filtered : prev;
      });
    }, 100); // check every 100ms

    return () => {
      clearInterval(timersRef.current);
      timersRef.current = null;
    };
  }, [fadeDuration, displayDuration]);

  // Keep addclass in sync with path
  useEffect(() => {
    if (pathSegments[2] === "userdashboard") {
      setAddclass(true);
    } else {
      setAddclass(false);
    }
  }, [pathSegments]);

  // Expose the function
  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}

      <div
        className={`notification-container allpopups chartpopnoti ${addclass ? "userdash" : ""}`}
      >
        <div className="notification-pop">
          {notifications.map((notification) => (
            <NotificationItem key={notification.id} data={notification} />
          ))}
        </div>
      </div>
    </NotificationContext.Provider>
  );
};

const NotificationItem = ({ data }) => {
  const notificationRef = React.useRef();

  useEffect(() => {
    const el = notificationRef.current;
    // ensure element is present
    if (!el) return;

    // Add show class on mount in next frame for transition
    requestAnimationFrame(() => {
      el.classList.add("show");
    });

    // If `removing` flag is set, add `hide` class to trigger CSS fade
    if (data.removing) {
      // small rAF to ensure classList change triggers transition
      requestAnimationFrame(() => {
        el.classList.add("hide");
      });
    } else {
      el.classList.remove("hide");
    }
  }, [data.removing, data.id]);

  return (
    <div
      ref={notificationRef}
      className={`notification ${data.removing ? "hide" : ""}`}
      // optional: data attributes for debug
      data-id={data.id}
    >
      <div className="custom-msg text-white">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill={
            data.type === "success"
              ? "rgba(100,205,138,1)"
              : "rgba(243,89,89,1)"
          }
        >
          {data.type === "success" ? (
            <path d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z" />
          ) : (
            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" />
          )}
        </svg>
        {data.message}
      </div>
    </div>
  );
};
